const migration0 = (state) => {
  return {
    ...state,
    brands: {
      ...state.brands,
      brandsList: [],
    },
  };
};

export default migration0;
